import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { YesNo } from 'interfaces';

export type Stamp = {
  stamp_id?: number; // 스탬프 idx
  frequency_id?: number; // 플퀀시 idx
  user_id?: number; // 회원 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  is_available?: (typeof YesNo)[keyof typeof YesNo]; // 전체사용가능 여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Stamp
   * --
   */
  getStamps: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_STAMP, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Stamp
   * --
   */
  getStamp: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_STAMP, { stamp_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Stamp
   * --
   */
  createStamp: async (body: Stamp) => {
    try {
      const res = await $http.post(APIConstant.CREATE_STAMP, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Stamp
   * --
   */
  updateStamp: async (body: Stamp) => {
    try {
      const { stamp_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_STAMP, {
        stamp_id: stamp_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Stamp
   * --
   */
  deleteStamp: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_STAMP, {
        stamp_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
